import { render, staticRenderFns } from "./menu-tree.vue?vue&type=template&id=7db25fb6&scoped=true&"
import script from "./menu-tree.vue?vue&type=script&lang=js&"
export * from "./menu-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db25fb6",
  null
  
)

export default component.exports